/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Ai_Integration_Embed_Desc5Inputs */

const en_svc_ai_integration_embed_desc5 = /** @type {(inputs: Svc_Ai_Integration_Embed_Desc5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Semantic search across documents, products, or support tickets, set up, indexed, and tuned for relevance.`)
};

const ar_svc_ai_integration_embed_desc5 = /** @type {(inputs: Svc_Ai_Integration_Embed_Desc5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`بحث دلالي عبر المستندات أو المنتجات أو تذاكر الدعم, إعداد وفهرسة وضبط من أجل الصلة.`)
};

const bn_svc_ai_integration_embed_desc5 = /** @type {(inputs: Svc_Ai_Integration_Embed_Desc5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ডকুমেন্ট, প্রোডাক্ট বা সাপোর্ট টিকিট জুড়ে সেম্যান্টিক সার্চ, সেটআপ, ইনডেক্সড ও রিলিভেন্সের জন্য টিউনড।`)
};

const de_svc_ai_integration_embed_desc5 = /** @type {(inputs: Svc_Ai_Integration_Embed_Desc5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Semantische Suche über Dokumente, Produkte oder Support-Tickets hinweg, eingerichtet, indiziert und auf Relevanz abgestimmt.`)
};

const es_svc_ai_integration_embed_desc5 = /** @type {(inputs: Svc_Ai_Integration_Embed_Desc5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Búsqueda semántica en documentos, productos o tickets de soporte, configurada, indexada y ajustada según su relevancia.`)
};

const fr_svc_ai_integration_embed_desc5 = /** @type {(inputs: Svc_Ai_Integration_Embed_Desc5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Recherche sémantique dans les documents, produits ou tickets d'assistance, configurée, indexée et optimisée pour leur pertinence.`)
};

const pt_svc_ai_integration_embed_desc5 = /** @type {(inputs: Svc_Ai_Integration_Embed_Desc5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pesquisa semântica em documentos, produtos ou tickets de suporte, configurada, indexada e ajustada para relevância.`)
};

const zh_svc_ai_integration_embed_desc5 = /** @type {(inputs: Svc_Ai_Integration_Embed_Desc5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`跨文档、产品或支持票证进行语义搜索、设置、索引和调整相关性。`)
};

const tr_svc_ai_integration_embed_desc5 = /** @type {(inputs: Svc_Ai_Integration_Embed_Desc5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Belgeler, ürünler ya da destek talepleri arasında anlamsal arama, kurulur, indekslenir, ilgiye göre ayarlanır.`)
};

const ru_svc_ai_integration_embed_desc5 = /** @type {(inputs: Svc_Ai_Integration_Embed_Desc5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Семантический поиск по документам, продуктам или тикетам поддержки: подключён, проиндексирован и дотюнен под релевантность.`)
};

const pl_svc_ai_integration_embed_desc5 = /** @type {(inputs: Svc_Ai_Integration_Embed_Desc5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wyszukiwanie semantyczne w dokumentach, produktach lub zgłoszeniach pomocy technicznej, skonfigurowane, indeksowane i dostrojone pod kątem trafności.`)
};

/**
* | output |
* | --- |
* | "Semantic search across documents, products, or support tickets, set up, indexed, and tuned for relevance." |
*
* @param {Svc_Ai_Integration_Embed_Desc5Inputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
const svc_ai_integration_embed_desc5 = /** @type {((inputs?: Svc_Ai_Integration_Embed_Desc5Inputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Ai_Integration_Embed_Desc5Inputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svc_ai_integration_embed_desc5(inputs)
	if (locale === "bn") return bn_svc_ai_integration_embed_desc5(inputs)
	if (locale === "de") return de_svc_ai_integration_embed_desc5(inputs)
	if (locale === "es") return es_svc_ai_integration_embed_desc5(inputs)
	if (locale === "fr") return fr_svc_ai_integration_embed_desc5(inputs)
	if (locale === "pt") return pt_svc_ai_integration_embed_desc5(inputs)
	if (locale === "zh") return zh_svc_ai_integration_embed_desc5(inputs)
	if (locale === "tr") return tr_svc_ai_integration_embed_desc5(inputs)
	if (locale === "ru") return ru_svc_ai_integration_embed_desc5(inputs)
	if (locale === "pl") return pl_svc_ai_integration_embed_desc5(inputs)
	return en_svc_ai_integration_embed_desc5(inputs)
});
export { svc_ai_integration_embed_desc5 as "svc_ai-integration_EMBED_desc" }